import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { UploadServiceService } from '../service/upload-service.service';

@Component({
    selector: 'app-subtype-creation',
    templateUrl: './subtype-creation.component.html',
    styleUrls: ['./subtype-creation.component.css'],
    standalone: false
})
export class SubtypeCreationComponent implements OnInit {
  displayedColumns: string[] = [ 'type','evaluate','action','delete' ];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  
  constructor(private uploadService:UploadServiceService) { }


  typeArray=[];
  type:String;
  evaluation:String="evaluate";
  subTypeValue:string;
  selectTypeValue :string;
  subTypeList=[]
  selectedTypeId =null;
  selectedEvalType = null;

  ngOnInit(): void {
    this.uploadService.getAllTypes().subscribe((data)=>{
      this.typeArray = data['resp'];
    })
  }

  createType(){
    console.log("Type",this.type);
    console.log("Evaluation",this.evaluation);
    let typeId = this.createTypeId(this.type);
    let typeBody = {typeId,type:this.type,flow_selected:"create-type","metadata" : {"evaluation":(this.evaluation=="evaluate")?true:false}};
    this.uploadService.createType(JSON.stringify(typeBody)).subscribe((data)=>{
      console.log("Type is created",data);
      alert("Type created successfully");
      this.uploadService.getAllTypes().subscribe((data)=>{
        this.typeArray = data["resp"];
        this.type="";
      })
    })
  }

  createTypeId(type:String){
    return type.replace(/\s+/g, '-').replace(/\W+/g, '-').replace(/\-$/, '').toLowerCase()
  }

  viewSubType(typeId,typeValue,selevalType){
    console.log("Open Sub Type by",typeId,selevalType)
    this.selectedTypeId = typeId;
    this.selectTypeValue = typeValue
    this.selectedEvalType = selevalType
    this.uploadService.getAllSubtypesByType(typeId).subscribe((data)=>{
      this.subTypeList = data["resp"];
    })
  }

  createSubType(){
    console.log("value of subtype",this.subTypeValue)
    let subTypeName = this.subTypeValue;
    let subTypeId = this.createTypeId(subTypeName);
    let subType = subTypeName;
    let subTypeCreation_body =  {
      "flow_selected":"create-subType",
      "typeId":this.selectedTypeId,
      "subTypeId":subTypeId,
      "subType":subType
    }
    this.uploadService.createSubTypeInType(JSON.stringify(subTypeCreation_body)).subscribe((data)=>{
      if(data){
        alert("SubType Created Successfully");
        const newSubType = data["resp"];
        this.subTypeList.unshift({
          typeId: newSubType.typeId,
          subTypeId: newSubType.subTypeId,
          subType: newSubType.subType   
        });
        this.subTypeValue ="";
      }
      else{
        alert("Unable to create subType");
        this.subTypeValue ="";
      }
    })
  }
  deleteSubType(typeId:string,subTypeId:string){
    console.log("To delete",typeId,subTypeId);
    if(!confirm("Are you sure you want to delete this subType? This will also delete all questions associated with it.")){
      return;
    }
    let deleteBody = {
      "flow_selected":"delete-subType",
      "typeId":typeId,
      "subTypeId":subTypeId
    }
    this.uploadService.createSubTypeInType(JSON.stringify(deleteBody)).subscribe((data)=>{
      if(data){
        alert("SubType Deleted Successfully");
        this.subTypeList = this.subTypeList.filter((subType)=>subType.subTypeId!=subTypeId);
      }
      else{
        alert("Unable to delete subType");
      }
    }
    )
  }

  deleteType(typeId:string){
    console.log("To delete type",typeId);
    if(!confirm("Are you sure you want to delete this type? This will also delete all subtypes and questions associated with it.")){
      return;
    }
    
    let deleteBody = {
      "flow_selected":"delete-type",
      "typeId":typeId
    }
    this.uploadService.createType(JSON.stringify(deleteBody)).subscribe((data)=>{
      if(data){
        alert("Type Deleted Successfully");
        this.typeArray = this.typeArray.filter((type)=>type.typeId!=typeId);
      }
      else{
        alert("Unable to delete type");
      }
    })
  }

}
